import React from 'react';
import styles from './Radio.module.scss'
import {RadioPropsInterface} from "./Radio.props.interface";

const Radio: React.FC<RadioPropsInterface> = (
    {
        size = 'medium',
        disabled = false,
        checked = false,
        label = '',
        children,
        className = undefined,
        ...rest
    }) => {

    return (
        <div className={[
            styles.radio,
            size ? styles[size] : styles.medium,
            disabled ? styles.disabled : null,
            className,
        ].filter(x => x ?? x).join(' ')}
             tabIndex={0}>
            <label className={styles.container}>
                <input
                    {...rest}
                    type="radio"
                    checked={checked}
                />
                <span className={styles.checkmark}></span>
                <span className={styles.label}>
                    {children}
                </span>
            </label>
        </div>
    );
};
export default Radio;
